import React from 'react'
import ErrorPage from 'pages/DefaultErrorPage/DefaultErrorPage'

import { isMobileOS } from 'utils/isMobileOS'
import { isUserAgent } from 'utils/isUserAgent'

import Mark from 'assets/mark.svg'

const urls = {
  Chrome: 'https://support.google.com/chrome/answer/95414',
  MobileChrome:
    'https://support.google.com/chrome/answer/95414?hl=en&co=GENIE.Platform%3DAndroid',
  Firefox: 'https://support.mozilla.org/pt-BR/kb/atualize-o-firefox',
  MobileFirefox:
    'https://support.mozilla.org/pt-BR/kb/update-latest-version-firefox-android',
  Safari: 'http://support.apple.com/kb/HT1338',
  MobileSafari: 'http://support.apple.com/kb/ht4623',
}

const OutdatedBrowser = () => {
  return (
    <ErrorPage
      img={{
        src: Mark,
        alt: 'Aviso',
      }}
      action="Navegador desatualizado"
      body="Atualize a versão do navegador para ter acesso as minhas funcionalidades."
      button={{
        text: 'Atualizar navegador',
        onClick: () => {
          const isChrome = isUserAgent('Chrome')
          const isFirefox = isUserAgent('Firefox')
          const isSafari = isUserAgent('Safari')
          const isMobile = isMobileOS()
          if (isChrome && !isMobile) {
            return window.open(urls['Chrome'], '__blank')?.focus()
          }
          if (isChrome && isMobile) {
            return window.open(urls['MobileChrome'], '__blank')?.focus()
          }
          if (isFirefox && !isMobile) {
            return window.open(urls['Firefox'], '__blank')?.focus()
          }
          if (isFirefox && isMobile) {
            return window.open(urls['MobileFirefox'], '__blank')?.focus()
          }
          if (isSafari && !isMobile) {
            return window.open(urls['Safari'], '__blank')?.focus()
          }
          if (isSafari && isMobile) {
            return window.open(urls['MobileSafari'], '__blank')?.focus()
          }
        },
      }}
    />
  )
}

export default OutdatedBrowser
